export default __webpack_public_path__ + "static/media/logo_003.061ab988.png";